(() => {
  const rows = info => [...(info?.querySelectorAll('[data-pending-addons] [data-addon]') || [])];
  const selected = info => rows(info).filter(row => row.querySelector('[data-addon-switch]')?.checked);
  const money = (cents, info) => window.IzuroCartActions.money(cents, info?.querySelector('[data-pending-addons]')?.dataset.currency);
  const quote = row => {
    const option = row.querySelector('[data-offer-variant]').selectedOptions[0];
    const base = Number(option?.dataset.unitPrice);
    return {row, option, id:Number(option?.value), base, total:Math.round(base * 0.85), code:(row.dataset.code || '').trim(), automatic:row.dataset.automatic === 'true'};
  };
  const snapshot = info => selected(info).map(quote);
  const api = window.IzuroPendingAddons = {
    selected, snapshot,
    paint(info) {
      if (!info) return;
      info.classList.toggle('iz-has-pending-addons', selected(info).length > 0);
      rows(info).forEach(row => {
        const item = quote(row);
        row.querySelector('[data-addon-original]').textContent = money(item.base, info);
        row.querySelector('[data-offer-price]').textContent = money(item.total, info);
      });
      const extras = snapshot(info).reduce((sum, item) => sum + item.total, 0);
      const tier = info.querySelector('izuro-quantity-offers');
      if (tier && info.classList.contains('izuro-product--offers')) { tier.paint(); return; }
      const button = info.querySelector('button[name="add"]');
      if (!button || button.disabled || button.getAttribute('aria-disabled') === 'true') return;
      const base = Number(button.dataset.unitPrice);
      if (!Number.isFinite(base)) return;
      const quantity = Number(info.querySelector('input[name="quantity"]')?.value || 1);
      const span = button.querySelector('span');
      if (!span) return;
      span.replaceChildren(document.createTextNode(money(base * quantity + extras, info) + ' — ' + (window.variantStrings?.addToCart || 'Add to cart')));
    },
    async purchase({info, main, addons, gifts = [], codes = [], expectedMain, trigger}) {
      const actions = window.IzuroCartActions;
      if(!Number.isFinite(expectedMain) || main.some(item=>!Number.isInteger(Number(item.id)) || !Number.isInteger(Number(item.quantity)) || Number(item.quantity)<1)) throw new Error('Choose an available product option before adding to cart.');
      addons.forEach(item => {
        if (!item.option || item.option.disabled || !Number.isFinite(item.base) || !item.id) throw new Error('Choose an available option for every selected extra.');
        if (Number(item.option.dataset.min || 1) > 1 || Number(item.option.dataset.step || 1) > 1 || (item.option.dataset.max && Number(item.option.dataset.max) < 1)) throw new Error('This extra cannot be purchased individually. Choose another option.');
        if (!item.automatic && !item.code) throw new Error('The add-on offer is not available yet. Unselect the extras to add your product.');
      });
      return actions.run(async () => {
        const marker = crypto.randomUUID ? crypto.randomUUID() : Date.now() + '-' + Math.random().toString(36).slice(2);
        const before = await actions.request('cart.js');
        const previousCodes = actions.codes(before);
        let changedCodes = false;
        try {
          const data = new FormData();
          main.forEach((item, index) => {
            data.append(`items[${index}][id]`, item.id);
            data.append(`items[${index}][quantity]`, item.quantity);
            if (item.sellingPlan) data.append(`items[${index}][selling_plan]`, item.sellingPlan);
            for (const [name, value] of item.properties || []) data.append(`items[${index}][properties][${name}]`, value);
            data.append(`items[${index}][properties][_izuro_purchase]`, marker);
          });
          addons.forEach((item, i) => {
            const index = main.length + i;
            data.append(`items[${index}][id]`, item.id);
            data.append(`items[${index}][quantity]`, 1);
            data.append(`items[${index}][properties][_izuro_purchase]`, marker);
            data.append(`items[${index}][properties][_izuro_extra]`, String(i));
          });
          gifts.forEach((item,i)=>{
            const index=main.length+addons.length+i;
            data.append(`items[${index}][id]`,item.id);data.append(`items[${index}][quantity]`,1);
            data.append(`items[${index}][properties][_izuro_purchase]`,marker);
            data.append(`items[${index}][properties][_izuro_offer_gift]`,'true');
            data.append(`items[${index}][properties][_izuro_offer_required]`,item.required);
          });
          const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {method:'POST', credentials:'same-origin', headers:{Accept:'application/json'}, body:data});
          const addedResponse = await response.json();
          if (!response.ok || addedResponse.status >= 400 || addedResponse.errors) throw new Error(addedResponse.description || 'One of these items is unavailable.');
          const requestedCodes = [...new Set([...previousCodes, ...codes, ...addons.filter(item => !item.automatic).map(item => item.code)].filter(Boolean))];
          changedCodes = requestedCodes.join(',') !== previousCodes.join(',');
          let cart = changedCodes ? await actions.request('cart/update.js', {discount:requestedCodes.join(',')}) : await actions.request('cart.js');
          const added = cart.items.filter(item => item.properties?._izuro_purchase === marker);
          for (const [i, item] of addons.entries()) {
            const lines = added.filter(line => line.properties?._izuro_extra === String(i));
            if (lines.reduce((sum,line) => sum + line.quantity, 0) !== 1 || lines.some(line => line.variant_id !== item.id) || lines.reduce((sum,line) => sum + line.final_line_price, 0) > item.total + 1) throw new Error('The 15% add-on offer could not be applied.');
          }
          for(const gift of gifts){
            const lines=added.filter(line=>line.properties?._izuro_offer_gift==='true'&&line.variant_id===gift.id);
            if(lines.reduce((sum,line)=>sum+line.quantity,0)!==1||lines.some(line=>line.final_line_price!==0))throw new Error('The complimentary gift could not be applied.');
          }
          const mainLines = added.filter(line => line.properties?._izuro_extra === undefined && line.properties?._izuro_offer_gift !== 'true');
          const expected = new Map();
          main.forEach(item => expected.set(Number(item.id), (expected.get(Number(item.id)) || 0) + Number(item.quantity)));
          const actual = new Map();
          mainLines.forEach(item => actual.set(item.variant_id, (actual.get(item.variant_id) || 0) + item.quantity));
          if (expected.size !== actual.size || [...expected].some(([id, quantity]) => actual.get(id) !== quantity) || mainLines.reduce((sum,line) => sum + line.final_line_price, 0) > expectedMain + main.length) throw new Error('The product offer could not be applied.');
          await actions.refresh(cart, trigger, true);
          rows(info).forEach(row => { row.querySelector('[data-addon-switch]').checked = false; });
          return cart;
        } catch (error) {
          try {
            let cart = await actions.request('cart.js');
            const updates = Object.fromEntries(cart.items.filter(item => item.properties?._izuro_purchase === marker).map(item => [item.key, 0]));
            if (Object.keys(updates).length) cart = await actions.request('cart/update.js', {updates});
            if (changedCodes) cart = await actions.request('cart/update.js', {discount:previousCodes.join(',')});
            await actions.refresh(cart);
          } catch {
            throw new Error('We could not confirm your selection. Check your bag before trying again.');
          }
          throw new Error(error.message + ' This new selection was removed; your previous bag is unchanged.');
        }
      });
    },
    async submit(form) {
      if (form.izAddonBusy) return;
      const info = form.closest('product-info');
      const addons = snapshot(info);
      const data = new FormData(form.form);
      const quantity = Number(data.get('quantity') || 1);
      const properties = [...data].filter(([key]) => /^properties\[.*\]$/.test(key)).map(([key,value]) => [key.slice(11,-1),value]);
      const main = [{id:Number(data.get('id')), quantity, sellingPlan:data.get('selling_plan'), properties}];
      form.izAddonBusy = true;
      form.handleErrorMessage();
      form.submitButton.setAttribute('aria-disabled','true');
      form.submitButton.classList.add('loading');
      const spinner = form.querySelector('.loading__spinner');
      spinner?.classList.remove('hidden');
      const controls = rows(info).flatMap(row => [...row.querySelectorAll('input,select')]).map(el => [el, el.disabled]);
      controls.forEach(([el]) => { el.disabled = true; });
      try {
        await api.purchase({info, main, addons, expectedMain:Number(form.submitButton.dataset.unitPrice) * quantity, trigger:form.submitButton});
      } catch (error) {
        form.handleErrorMessage(error.message);
      } finally {
        controls.forEach(([el,disabled]) => { el.disabled = disabled; });
        form.izAddonBusy = false;
        form.submitButton.removeAttribute('aria-disabled');
        form.submitButton.classList.remove('loading');
        spinner?.classList.add('hidden');
        api.paint(info);
      }
    }
  };
  const repaint = () => document.querySelectorAll('product-info').forEach(info => api.paint(info));
  document.addEventListener('product-info:loaded', repaint);
  document.addEventListener('shopify:section:load', repaint);
  if (typeof subscribe === 'function') subscribe(PUB_SUB_EVENTS.variantChange, repaint);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', repaint, {once:true}); else repaint();
})();
